// @ts-ignore
import toastr from 'toastr';
import TranslationService from './TranslationService';
import 'toastr/toastr.scss';

const InfoMessageService = {
  success: (message: string, title?: string, options?: any) => {
    toastr.success(
      message,
      title ? title : TranslationService.translate('InfoMessageSuccessTitle'),
      options
    );
  },

  error(message: string, title?: string, options?: any) {
    toastr.error(
      message,
      title ? title : TranslationService.translate('InfoMessageErrorTitle'),
      options
    );
  },

  warning(message: string, title?: string, options?: any) {
    toastr.warning(
      message,
      title ? title : TranslationService.translate('InfoMessageWarningTitle'),
      options
    );
  },
};

export default InfoMessageService;
